import React from 'react';
import styled from 'styled-components';

// Define types for the props
interface GenericCheckboxProps {
  label: string;  // Label text for the checkbox
  checked: boolean;  // Checked state of the checkbox (true or false)
  onChange: (checked: boolean) => void;  // Change handler
}

// Styled component for the checkbox container
const CheckboxWrapper = styled.div`
  width: 100%;  // Make the wrapper take up full width
  min-width: 200px;  // Set a minimum width for larger screens
  margin-bottom: 1rem;  // Space between checkboxes

  @media (max-width: 576px) {
    min-width: 100%;  // Full width on mobile devices
  }
`;

// Styled component for the checkbox label
const CheckboxLabel = styled.label`
  font-size: 1rem;
  font-weight: 600;
  color: #000;  // Black text for the label
  margin-bottom: 0.5rem;
  display: block;  // Make sure label appears above the checkbox
`;

// Styled component for the checkbox input (custom style)
const CheckboxInput = styled.input`
  width: auto;  // Allow the checkbox to use its natural width
  margin-right: 10px;  // Space between checkbox and label text
  cursor: pointer;  // Change the cursor to indicate interactivity

  &:focus {
    outline: none;  // Remove default focus outline
    box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.5);  // Add custom focus outline
  }

  &:checked {
    background-color: #007bff;  // Custom background color when checked
    border-color: #007bff;  // Same border color for consistency
  }
`;

const GenericCheckbox: React.FC<GenericCheckboxProps> = ({ label, checked, onChange }) => {
  return (
    <CheckboxWrapper>
      {/* Checkbox Label */}
      <CheckboxLabel>
        <CheckboxInput
          type="checkbox"
          checked={checked}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)}  // Pass the checked value to onChange
        />
        {label}
      </CheckboxLabel>
    </CheckboxWrapper>
  );
};

export default GenericCheckbox;
